import { render } from "./GetAccquintedTwo.vue?vue&type=template&id=1ae2718e&scoped=true"
const script = {}

import "./GetAccquintedTwo.vue?vue&type=style&index=0&id=1ae2718e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae2718e"]])

export default __exports__